import Vue from 'vue'
// import VueRouter from 'vue-router'
import {createRouter, createWebHistory, createWebHashHistory} from "vue-router"
// Vue.use(VueRouter);
import routes from './routes'

//
// const storeRouter = {
//     path: '/dept',
//     component: () => import( '@/pages/VueAuth.vue'),
//     name:'auth1',
//     meta: {title: '登录校验中'},
//     children:[]
// }
//
// const files = require.context('./routers', false, /\.js$/)
//
// files.keys().forEach(key => {
//     let menuLocal = files(key).default;
//     for(var  a in menuLocal){
//         storeRouter.children.push(menuLocal[a]);
//     }
// })
// routes.push(storeRouter);





const routerObj = createRouter({
	// 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
	// history: createWebHashHistory(), //不推荐，会在采用#url 的方式
	history:  createWebHistory(), //推荐采用这个方式，正常的url格式, 部署需要配置nginx
	routes: routes, // `routes: routes` 的缩写
})
// routerObj.beforeEach((to, from, next) => {
//      if(to.name == null){
//         next({
//             path:'/404'
//         });
//      }else{
//        document.title =  to.meta.title;
//        next();
//      }
// })


console.log("routerObj", routerObj)
console.log("routerList", routes)
export default routerObj;
